import { useDroppable } from '@dnd-kit/core';
import { horizontalListSortingStrategy, SortableContext } from '@dnd-kit/sortable';
import { Add } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import { DreConfigConfiguracoesItem } from 'pages/financeiro/dre/configuracao/components/configuracoes/DreConfigConfiguracoesItem';
import { DreConfiguracao } from 'pages/financeiro/dre/configuracao/types';

export function DreConfigConfiguracoesLine({ configuracoes, last, lineId }: { lineId: number; last: boolean; configuracoes: DreConfiguracao[] }) {
    const { setNodeRef } = useDroppable({
        id: `line-${lineId}`,
    });

    return (
        <SortableContext
            strategy={horizontalListSortingStrategy}
            items={configuracoes.map((config) => `configuracao-${config.idDreMercadologicaConfiguracao}`)}
        >
            <Box
                ref={setNodeRef}
                sx={{
                    gap: 1,
                    padding: 1,
                    minHeight: 42,
                    width: '100%',
                    display: 'flex',
                    overflow: 'auto',
                    alignItems: 'center',
                    borderBottomWidth: last ? 0 : 1,
                    borderBottomStyle: 'solid',
                    borderBottomColor: 'grey.300',
                }}
            >
                {!configuracoes.length && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flex: 1 }}>
                        <Add sx={{ fontSize: 13, color: 'grey.500' }} />
                        <Typography sx={{ fontSize: 13, color: 'grey.500' }}>Arraste para adicionar uma nova linha</Typography>
                    </Box>
                )}

                {configuracoes.map((config) => (
                    <DreConfigConfiguracoesItem key={config.idDreMercadologicaConfiguracao} configuracao={config} />
                ))}
            </Box>
        </SortableContext>
    );
}
